import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import Header from 'Components/HeaderPlain';

const DailyReport = () => {
    const [reportData, setReportData] = useState({});
    const [loading, setLoading] = useState(true);
    const [TotalCount, setTotalCount] = useState();
    const [matchingCount, setMatchingCount] = useState(0);
    const [eventLanguageData, setEventLanguageData] = useState([]);

    useEffect(() => {
        const languageNameMap = {
            'en-IN': 'English', 'hi-IN': 'Hindi', 'mr-IN': 'Marathi', 'te-IN': 'Telugu', 'ta-IN': 'Tamil',
            'kn-IN': 'Kannada', 'gu-IN': 'Gujarati', 'ml-IN': 'Malayalam', 'bn-IN': 'Bengali', 'pa-IN': 'Punjabi',
            'ur-IN': 'Urdu', 'or-IN': 'Odia', 'as-IN': 'Assamese', 'kok-IN': 'Konkani', 'sd-IN': 'Sindhi',
            'ne-IN': 'Nepali', 'si-IN': 'Sinhala', 'bh-IN': 'Bhojpuri', 'ma-IN': 'Maithili', 'mi-IN': 'Mising',
            'raj-IN': 'Rajasthani', 'br-IN': 'Bodo', 'sa-IN': 'Santhali', 'bo-IN': 'Tibetan', 'ch-IN': 'Chhattisgarhi',
            'gju-IN': 'Gujarati', 'kac-IN': 'Kachchhi', 'udb-IN': 'Udaipur', 'hari-IN': 'Haryanvi', 'tl-IN': 'Tagalog',
            'assamese-IN': 'Assamese', 'ar-IN': 'Arabic', 'tamil-IN': 'Tamil', 'bhojpuri-IN': 'Bhojpuri',
            'dogri-IN': 'Dogri', 'luh-IN': 'Lushai'
        };

        const getCount = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://ecoclubs.education.gov.in/api/report-themelangCount', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({})
                });

                const result = await response.json();
                if (result.status === 'success') {
                    const counts = result.data;
                    setMatchingCount(counts.matchingCount - 2);

                    const languageByEvent = counts.themeLangCounts || [];
                    const last24HoursLangWise = counts.eventCounts?.[0]?.last24hrsLangWise || [];

                    const formattedLanguageByEvent = languageByEvent.map(item => {
                        const last24HrLang = last24HoursLangWise.find(langEntry => langEntry.lang === item.lang);
                        return {
                            language: languageNameMap[item.lang] || item.lang,
                            count: item.count,
                            last24HoursCount: last24HrLang?.count || 0
                        };
                    });

                    setEventLanguageData(formattedLanguageByEvent);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        const fetchReport = async () => {
            try {
                const res = await fetch('https://ecoclubs.education.gov.in/api/get-recent-registrations', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({})
                });

                const data = await res.json();
                if (data?.data?.dataCount) {
                    setReportData(data.data.dataCount.summaryByState || {});
                    setTotalCount(data.data.dataCount.summaryByState.TOTAL || {});
                }
            } catch (err) {
                console.error('Failed to fetch report data:', err);
            } finally {
                setLoading(false);
            }
        };

        // getCount();
        fetchReport();
    }, []);

    const totalEvents = eventLanguageData.reduce((total, lang) => total + lang.count, 0);

    return (
        <>
            <Header />
            <div className="container mt-5" style={{ paddingBottom: '110px' }}>
                <h3 className="text-center"><strong>Total Numbers of Schools Onboarded on Eco Clubs For Mission LiFE Portal</strong></h3>
                <h4 className="text-center text-primary" style={{ color: 'black', WebkitTextFillColor: 'black' }}>
                    <span>
                        Total Schools Onboarded:&nbsp;
                        <strong style={{ marginRight: '60px' }}>
                            {TotalCount?.total ? TotalCount.total - 2 : 0 || 0}
                        </strong>
                    </span>
                    <span>
                        Schools Onboarded in Last 24 Hours:&nbsp;
                        <strong style={{ marginRight: '60px' }}>
                            {TotalCount?.last24Hours || 0}
                        </strong>
                    </span>
                    {/* <span>
                        Total Events Created:&nbsp;
                        <strong>{totalEvents}</strong>
                    </span> */}
                </h4>

                {/* State-wise onboarding table */}
                <div className="mt-5">
                    <h4><strong>States/UTs/ABs-wise Schools Onboarded</strong></h4>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>States/UTs/ABs</th>
                                <th className="text-center">Total Schools Onboarded</th>
                                <th className="text-center">Last 24 Hrs</th>
                                <th>More Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="text-center">Loading...</td>
                                </tr>
                            ) : (
                                <>
                                    {Object.keys(reportData)
                                        .filter(state => state !== 'TOTAL')
                                        .sort((a, b) => a.localeCompare(b))
                                        .map((state, index) => {
                                            const total = reportData[state]?.total || 0;
                                            const last24Hours = reportData[state]?.last24Hours || 0;

                                            return (
                                                <tr key={state}>
                                                    <td>{index + 1}</td>
                                                    <td>{state}</td>
                                                    <td className="text-center">{total}</td>
                                                    <td className="text-center">{last24Hours}</td>
                                                    <td className="text-center">
                                                        {(total > 0 || last24Hours > 0) ? (
                                                            <NavLink style={{ color: 'blue' }} to={`/daily-report-district/${state}`}>
                                                                Click Here
                                                            </NavLink>
                                                        ) : (
                                                            <span style={{ color: 'red' }}>No Data</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                        <td colSpan="2" className="text-right">Total</td>
                                        <td className="text-center">
                                            {TotalCount?.total ? TotalCount.total - 2 : 0}
                                        </td>
                                        <td className="text-center">
                                            {TotalCount?.last24Hours || 0}
                                        </td>
                                        <td></td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default DailyReport;
